import React, { useContext, useEffect } from "react";
import Availabiity from "../../../clientSupportingComponents/Availability/Availability";
import "./patientAvailabilityStart.scss";
import start from "assets/Availability-Start.svg";
import AvailabilityBuilderBack from "assets/Availability-Builder-Back.svg";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { myContext } from "hooks/useContext/useContext";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const PatientAvailabilityStart: React.FC<{}> = () => {
  const { availabilityDate, setAvailiabilityDate, validateUrl } =
    useContext(myContext);
  const navigate = useNavigate();
  const today = new Date();

  const onChange = (e: any) => {
    setAvailiabilityDate(e);
  };

  const HandleReviewNavigation = () => {
    navigate(
      "/appointments-availability-review",
    );
  };

  const HandleBuilderNavigation = () => {
    navigate(
      "/appointments-availability-builder",
    );
  };

  const disabledDate = (current: any) => {
    // If the date is before today, disable it
    return current && current < today.setHours(0, 0, 0, 0);
  };

  useEffect(() => {
    validateUrl && navigate("/appointments", { replace: true });
  }, [validateUrl, navigate]);

  return (
    <div className="primary-PatientAvailabilityStart-container">
      <div>
        <div className="Location-navigation">
          <div className="Navigation">
            <img
              className="Home-img"
              src={AvailabilityBuilderBack}
              alt="Loading"
              onClick={HandleBuilderNavigation}
            />
          </div>
        </div>
        <Availabiity />
        <div className="secondary-PatientAvailabilitystart-container">
          <img className="Start-img" src={start} alt="Loading" />
          <div className="primary-text">
            Input the start date for this availability.
          </div>
          <div className="primary-date">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={availabilityDate ?? null}
                onChange={(e: any) => e && onChange(e)}
                format="MM/DD/YYYY"
                shouldDisableDate={disabledDate}
                slotProps={{
                  textField: {
                    size: "small",
                  },
                }}
              />
            </LocalizationProvider>
          </div>
        </div>
      </div>
      <div className="Button-container">
        <Button
          className="Next-button"
          variant="contained"
          onClick={HandleReviewNavigation}
          disabled={!availabilityDate}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default PatientAvailabilityStart;
